import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab } from '@material-ui/core'





export default class AlertCv extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialogÍ">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>
                  

                    <DialogActions className="pm-dialog-bottom-buttons">

                        <Button variant="outlined" onClick={this.props.yesFunction} className='pm-save-button'>
                            {this.props.adaugaText}
                        </Button>

                        {this.props.viewFile &&
                        <Button style={{width:'fit-content', color:'orange', borderColor:'orange'}} variant="outlined" onClick={this.props.view}>
                            View
                            </Button>
                    }


                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}